// StripePayment.js
import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Layouts from "../Components/Layouts/Layouts";
import "../styles/StripePayment.css";
import axios from "../axiosinstens";
import { environment } from "../environment";
import logo from "../assets/images/weaccept.png";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const StripePayment = ({seminar_data, settings, organizer}) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [registerData, setRegisterData] = useState({
    selectedPlayersData: [{ name: organizer.name, email: organizer.email, price: seminar_data.amount }],
    totalPrice: seminar_data.amount,
    eventID: seminar_data._id,
    currency: settings.currency_symbol
  });

  const [storedUser, setStoredUser] = useState({
    name: organizer.name,
    email: organizer.email,
  });

  const [authToken, setAuthToken] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
      const initStripe = async () => {
        //---------------------------
        // 1️⃣ Decrypt JWT Token
        //---------------------------
        let decryptedToken = "";
  
        const encryptedToken = localStorage.getItem("tokenJwt");
        if (encryptedToken) {
          try {
            const bytes = CryptoJS.AES.decrypt(
              encryptedToken,
              "secret-key-token-seminar"
            );
            decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
            setAuthToken(decryptedToken);
          } catch (err) {
            console.error("Token decrypt error");
          }
        }
  
        //---------------------------
        // 2️⃣ If token missing → logout
        //---------------------------
        if (!decryptedToken) {
          localStorage.removeItem("organizer");
          localStorage.removeItem("tokenJwt");
          setIsLoggedIn(false);
          navigate("/login");
          return;
        }
      };
  
      initStripe();
    }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      swal("Error", error.message, "error");
      return;
    }

    try {
      const response = await fetch(`${environment.baseURL}createPaymentIntent`, {
        method: "POST",
        headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: registerData.totalPrice,
          email: storedUser.email,
          payment_description: "Payment for Play Pro",
          user_name: storedUser.name,
          paymentMethodId: paymentMethod.id,
          currency: settings.currency_name
        }),
      });

      const { client_secret, error: intentError } = await response.json();

      if (intentError) {
        console.error(intentError);
        return;
      }

      const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(client_secret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: storedUser.name,
            email: storedUser.email,
          },
        },
      });

      if (confirmError) {
        console.error(confirmError.message);
        return;
      }

      if (paymentIntent.status === "succeeded") {
        const crgrespons = await fetch(`${environment.baseURL}getcharge_id`, {
          method: "POST",
          headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" },
          body: JSON.stringify({ payment_intent_id: paymentIntent.id }),
        });

        const { chargeidget } = await crgrespons.json();
        const dataToSend = {
          selectedPlayersData: registerData.selectedPlayersData,
          totalPrice: registerData.totalPrice,
          eventID: registerData.eventID,
          trn_id: chargeidget,
          paymentIntent: paymentIntent.id
        };

        await axios.post("updatemyseminar", dataToSend, {
          headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" }
        });

        swal("Success", "Your payment was successful!", "success").then(() => {
          navigate(`/seminar`);
        });
      }
    } catch (err) {
      swal("Error", "An error occurred during payment", "error");
    }
  };

  return (
    <Layouts>
      <div className="payy">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              {registerData && (
                <div className="invoice">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Player Name</th>
                        <th>Email</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {registerData.selectedPlayersData.map((player, index) => (
                        <tr key={index}>
                          <td>{player.name}</td>
                          <td>{player.email}</td>
                          <td>{registerData.currency}{seminar_data.total_amount}</td>
                        </tr>
                      ))}
                      <tr>
                        <td></td>
                        <td>Offer Code {seminar_data.offer_code}</td>
                        <td>{registerData.currency}{seminar_data.total_amount - seminar_data.amount}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td><strong>Total</strong></td>
                        <td><strong>{registerData.currency}{registerData.totalPrice}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="col-md-6">
              <div className="payment-form">
                <img src={logo} alt="Logo" className="logo" />
                <form onSubmit={handleSubmit}>
                  <div className="card-element">
                    <CardElement />
                  </div>
                  <button type="submit" disabled={!stripe}>
                    Pay {registerData.currency}{registerData.totalPrice}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default StripePayment;
